import React, { useState } from "react";
import { elakayAutoText } from "../../pageInside/dataElakay";



const D = {
  blue: "#3b82f6", blueLt: "#dbeafe",
  green: "#10b981", greenLt: "#f0fdf4",
  red: "#ef4444", redLt: "#fff5f5",
  txt1: "#0f172a", txt2: "#475569", txt3: "#94a3b8",
  border: "#e2e8f0", bg: "#f8fafc",
  font: "'Inter','Segoe UI',system-ui,sans-serif",
  radius: 8,
};

const loadingTicket = (array, allticket) => {
  const { _id, subTicket } = allticket;
  if (!Array.isArray(array) || !Array.isArray(subTicket)) {
    console.error("Invalid input: both arguments must be arrays.");
    return [];
  }
  if (subTicket?.length === 0 || array?.length === 0) {
    console.warn("No data to process: subTicket or array is empty.");
    return [];
  }
  return array.filter(v => v._id != _id).filter(item => subTicket.includes(item._id));
};

const FormPageTicket = (props) => {
  const {
    laguangeElakay, infoSource,
    editAdd, setEditAdd, editAddByJson = false,
    nameObj, paragra, setParagra, ObjetPage,
    edit_add, token, AlllanguageSelect, languageUsertra,
    languageTradictor, updateLanguageElakay0, deleteLanguageElakay0,
    buttonAddLanguage
  } = props;

  let objValue = { ticket: '', subTicket: [] };

  const checkProdKeyExit = (ad) => {
    let ac = ad != undefined ? ad[0] : [];
    let ent = Object.keys(ac ? ac : {});
    return ent.every((key) => ac[key] != undefined) ? true : false;
  };

  const checkObjEmpty = (a) => JSON.stringify(a) === '{}';

  const [addSubTicket, setAddSubTicket] = useState(false);
  const [allticket, setAllTicket] = useState(objValue);
  const [error, setError] = useState('');

  const { ticket, subTicket } = allticket;

  const checkProductTrue = (ad) => {
    let array = Object.values(ad)?.map(e => e !== '');
    return array.every(a => a === true) && true;
  };

  const checkUndefName = (a, b) => {
    let aa = a && Object.keys(a);
    return a && aa.includes(b);
  };

  const inputOK = (a, b, c) => {
    if (c == undefined) return { v: b, s: 'neutral' };
    else if (c == {}) return { v: "", s: 'invalid' };
    else if (checkUndefName(c, a)) return { v: c[a], s: 'valid' };
    else return { v: "", s: 'invalid' };
  };

  const buttonAdd = () => {
    updateLanguageElakay0(languageTradictor._id, token, {
      [nameObj]: {
        _id: allticket._id,
        ticket,
        subTicket: subTicket.filter(v => v != allticket._id),
      }
    }, true).then(data => {
      if (data.error) { setError(data.error); }
      else { AlllanguageSelect(); languageUsertra(); setAddSubTicket(false); setAllTicket(objValue); }
    });
  };

  const handleChange = name => event => {
    setAllTicket({ ...allticket, [name]: event.target.value });
  };

  const handleLanguage = () => event => {
    const value = event.target.value;
    let newObj = languageTradictor[nameObj][value];
    if (value == '') {
      setAddSubTicket(false);
      setAllTicket(objValue);
    } else {
      setAddSubTicket(true);
      setAllTicket(newObj);
    }
  };

  const CheckInputBool = (title) => title !== '';

  const handleToggle = (ID) => () => {
    let newSubticket;
    if (subTicket.includes(ID)) {
      newSubticket = subTicket.filter(v => v != ID);
    } else {
      newSubticket = subTicket.concat([ID]);
    }
    setAllTicket({ ...allticket, subTicket: newSubticket });
  };

  const checkSel = (a) => subTicket.includes(a);

  let entries = languageTradictor[nameObj] != undefined && languageTradictor[nameObj]?.length > 0
    ? Object.entries(languageTradictor[nameObj])
    : [];

  // ── shared style helpers ──────────────────────────────────────────────────
  const inpSt = {
    width: "100%", padding: "7px 10px", boxSizing: "border-box",
    border: `1px solid ${D.border}`, borderRadius: D.radius,
    fontSize: 13, color: D.txt1, fontFamily: D.font,
    background: "#fff", outline: "none",
  };

  const lblSt = {
    display: "block", fontSize: 11, fontWeight: 700, color: D.txt3,
    textTransform: "uppercase", letterSpacing: 0.6, marginBottom: 4,
  };

  const txt = (key) => {
    const val = infoSource.laguangeElakay?.("frontElakayHardcodedText", infoSource.languageAPI)?.languageFormPageTicket?.[key];
    return typeof val === 'string' ? val : '';
  };

  const __elakayText = (key, fallback = '') => {
    const val = infoSource?.laguangeElakay?.("frontElakayHardcodedText", infoSource.languageAPI)?.formPageTicket?.[key];
    return typeof val === 'string' ? val : fallback;
  };

  // ── sub-renders ───────────────────────────────────────────────────────────
  const selectObAr = () => (
    <div style={{ marginBottom: 16 }}>
      <label style={lblSt}>{infoSource.language(infoSource, "label", "selLanguaComp")}</label>
      <select onChange={handleLanguage()}
        style={{ ...inpSt, cursor: "pointer" }}>
        <option value={''}>{txt("t001")}</option>
        {!checkObjEmpty(languageTradictor) && languageTradictor[nameObj]?.map((ob, j) =>
          <option key={j} value={j}>{ob.ticket}</option>
        )}
      </select>
    </div>
  );

  const formSubTicket = (array, aId) => (
    <>
      {/* Current ticket label */}
      <div style={{
        padding: "10px 14px", marginBottom: 12,
        background: D.blueLt, borderRadius: D.radius,
        border: `1px solid #bfdbfe`,
      }}>
        <span style={{ fontSize: 13, fontWeight: 700, color: D.blue }}>{ticket}</span>
      </div>

      {/* Sub-ticket checkboxes */}
      <div style={{ marginBottom: 14 }}>
        <label style={lblSt}>{elakayAutoText("h_52f48b6a59ee89", "Sub-tickets")}</label>
        <div style={{
          display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
          gap: 8,
        }}>
          {array && array.filter((v, j) => j > 3 && v._id != aId)?.map((c, i) => (
            <label key={i}
              style={{
                display: "flex", alignItems: "center", gap: 8, padding: "8px 12px",
                borderRadius: D.radius, border: `1px solid ${checkSel(c._id) ? D.blue : D.border}`,
                background: checkSel(c._id) ? D.blueLt : "#fff",
                cursor: "pointer", fontFamily: D.font, transition: "all .12s",
              }}>
              <input
                onChange={handleToggle(c._id)}
                value={c._id}
                checked={checkSel(c._id) ? true : false}
                type="checkbox"
                id={c._id + "_" + c.ticket}
                style={{ width: 15, height: 15, cursor: "pointer", accentColor: D.blue, flexShrink: 0 }}
              />
              <span style={{ fontSize: 13, color: checkSel(c._id) ? D.blue : D.txt2, fontWeight: checkSel(c._id) ? 600 : 400 }}>
                {c.ticket}
              </span>
            </label>
          ))}
        </div>
      </div>
    </>
  );

  const formInput = () => (
    <div onBlur={() => setError("")}>

      {/* Section header */}
      <div style={{
        paddingBottom: 10, marginBottom: 14,
        borderBottom: `1px solid ${D.border}`,
      }}>
        <h3 style={{ fontSize: 13, fontWeight: 700, color: D.txt2, margin: 0 }}>
          {txt("t002")}
        </h3>
      </div>

      {/* Error */}
      {error && (
        <div style={{
          display: "flex", alignItems: "center", gap: 8, padding: "8px 12px",
          background: D.redLt, borderRadius: 6, border: `1px solid #fca5a5`, marginBottom: 12,
        }}>
          <span>⚠</span>
          <span style={{ fontSize: 12, color: "#991b1b" }}>{error}</span>
        </div>
      )}

      {/* Ticket title */}
      <form onSubmit={e => e.preventDefault()}>
        <div style={{ marginBottom: 14 }}>
          <label style={lblSt}>{txt("t003")}</label>
          <input onChange={handleChange('ticket')} type="text" value={ticket}
            placeholder={__elakayText("t001", "enter your the title of ticket")}
            style={inpSt} />
        </div>

        {addSubTicket && formSubTicket(languageTradictor[nameObj], allticket._id)}
      </form>

      {/* Submit */}
      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 4 }}>
        {buttonAddLanguage(buttonAdd, CheckInputBool(ticket))}
      </div>
    </div>
  );

  return (
    <>
      {selectObAr()}
      {formInput()}
    </>
  );
};

export default FormPageTicket;
